module.exports = __webpack_public_path__ + "img/bg.94403957.png";